// Women's measurements tab visibility
// Shows/hides the 4th tab and its content based on gender context
window.evdnceApplyMeasurements = function(g) {
  var gender = g || sessionStorage.getItem('evdnce_gender');
  var show = (gender !== 'men');
  document.querySelectorAll('[data-womens-tab], [data-womens-tab-content]').forEach(function(el) {
    el.style.display = show ? '' : 'none';
  });
};

(function() {
  function init() {
    if (typeof window.evdnceApplyMeasurements === 'function') {
      window.evdnceApplyMeasurements();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
